import type { BusinessType, DetailedOwnListing } from "@/lib/types";
import type { SearchHookLocation } from "@repo/maps";
import { atom } from "jotai";

export type ValuationToolStep =
  | "LOCATION"
  | "BUSINESS_TYPE"
  | "DETAILS"
  | "EMAIL"
  | "RESULTS";

export type ValuationToolData = {
  listing?: DetailedOwnListing;
  step: ValuationToolStep;
  location?: SearchHookLocation;
  zipCode?: string;
  businessType?: BusinessType;
  establishmentDate?: Date;
  sameName?: boolean;
  revenue?: number;
  sde?: number;
  ownerWeeklyHours?: number;
  sustainableAdvantage?: boolean;
  profit?: number;
  steadyCashFlow?: boolean;
  email?: string;
};

export const valuationToolAtom = atom<ValuationToolData>({
  listing: undefined,
  step: "LOCATION",
  location: undefined,
  zipCode: undefined,
  businessType: undefined,
  establishmentDate: undefined,
  sameName: undefined,
  revenue: undefined,
  sde: undefined,
  ownerWeeklyHours: undefined,
  sustainableAdvantage: undefined,
  profit: undefined,
  steadyCashFlow: undefined,
  email: undefined,
});
